// Dev mock seed data — používa sa iba keď REACT_APP_DEV_MOCK=true
// Žiadny prod kód nesmie z tohto súboru čítať.

const USER_ID = '00000000-0000-0000-0000-000000000001';
const WS_SZCO_ID = '11111111-1111-1111-1111-111111111111';
const WS_SRO_ID = '22222222-2222-2222-2222-222222222222';

const today = new Date();
const iso = (d) => d.toISOString().slice(0, 10);
const daysAgo = (n) => {
  const d = new Date(today);
  d.setDate(d.getDate() - n);
  return iso(d);
};
const daysFromNow = (n) => {
  const d = new Date(today);
  d.setDate(d.getDate() + n);
  return iso(d);
};

export const MOCK_USER = {
  id: USER_ID,
  email: 'design@todue.sk',
  user_metadata: { full_name: 'Jožko Designer' },
};

export const MOCK_SESSION = {
  user: MOCK_USER,
  access_token: 'dev-mock-token',
  refresh_token: 'dev-mock-refresh',
  expires_at: Math.floor(Date.now() / 1000) + 86400,
  expires_in: 86400,
  token_type: 'bearer',
};

const seed = {
  users_profile: [
    {
      id: USER_ID,
      full_name: 'Jožko Designer',
      default_workspace_id: WS_SZCO_ID,
      created_at: daysAgo(180) + 'T10:00:00Z',
      // Konzistentné s CURRENT_TERMS_VERSION (frontend/src/lib/terms.js) — inak by dev-mock
      // preview vždy ukazovalo "Podmienky sa zmenili" interstitial.
      terms_accepted_at: daysAgo(180) + 'T10:00:00Z',
      terms_version: '2026-10-08',
    },
  ],

  workspaces: [
    {
      id: WS_SZCO_ID,
      user_id: USER_ID,
      name: 'Jožko Mrkvička',
      type: 'szco',
      ico: '12345678',
      dic: '1020304050',
      ic_dph: 'SK1020304050',
      iban: 'SK8911000000002612345678',
      bic: 'TATRSKBX',
      bank: 'Tatra banka',
      address: 'Hlavná 12, 811 01 Bratislava',
      email: 'jozko@todue.sk',
      phone: '+421 905 123 456',
      brand_color: '#2bbf85',
      fa_number_format: '{YYYY}{NNN}',
      fa_counter: 10,
      is_dph_payer: true,
      default_dph_rate: 23,
      notice: null,
      created_at: daysAgo(180) + 'T10:00:00Z',
    },
    {
      id: WS_SRO_ID,
      user_id: USER_ID,
      name: 'Studio Todue s.r.o.',
      type: 'sro',
      ico: '50123456',
      dic: '2120304050',
      ic_dph: 'SK2120304050',
      iban: 'SK1209000000000123456789',
      bic: 'GIBASKBX',
      bank: 'Slovenská sporiteľňa',
      address: 'Mlynské nivy 49, 821 09 Bratislava',
      email: 'fakturacia@studiotodue.sk',
      phone: '+421 902 222 333',
      brand_color: '#3a7bd5',
      fa_number_format: '{YYYY}{NNNN}',
      fa_counter: 4,
      is_dph_payer: true,
      default_dph_rate: 23,
      notice: 'Splatnosť 14 dní',
      created_at: daysAgo(120) + 'T10:00:00Z',
    },
  ],

  clients: [
    {
      id: 'c0000001-0000-0000-0000-000000000001',
      workspace_id: WS_SZCO_ID,
      name: 'Webdesign Bratislava s.r.o.',
      ico: '47123456',
      dic: '2023456789',
      ic_dph: 'SK2023456789',
      address: 'Bajzova 8, 821 08 Bratislava',
      email: 'fakturacia@webdesignba.sk',
      iban: 'SK1109000000000111111111',
      is_pinned: true,
      custom_color: null,
      created_at: daysAgo(160),
    },
    {
      id: 'c0000002-0000-0000-0000-000000000002',
      workspace_id: WS_SZCO_ID,
      name: 'Marketing Pro a.s.',
      ico: '36987654',
      dic: '2022888777',
      ic_dph: 'SK2022888777',
      address: 'Štúrova 14, 040 01 Košice',
      email: 'mp@marketingpro.sk',
      iban: null,
      is_pinned: true,
      custom_color: null,
      created_at: daysAgo(150),
    },
    {
      id: 'c0000003-0000-0000-0000-000000000003',
      workspace_id: WS_SZCO_ID,
      name: 'Anna Krátka',
      ico: '50555111',
      dic: '1080111222',
      ic_dph: null,
      address: 'Tatranská 5, 974 01 Banská Bystrica',
      email: 'anna.kratka@gmail.com',
      iban: null,
      is_pinned: false,
      custom_color: null,
      created_at: daysAgo(90),
    },
    {
      id: 'c0000004-0000-0000-0000-000000000004',
      workspace_id: WS_SZCO_ID,
      name: 'Kaviareň U Janka',
      ico: '51444222',
      dic: '2120555666',
      ic_dph: null,
      address: 'Hlavná 1, 080 01 Prešov',
      email: 'janko@kaviarenujanka.sk',
      iban: null,
      is_pinned: false,
      custom_color: null,
      created_at: daysAgo(60),
    },
    {
      id: 'c0000005-0000-0000-0000-000000000005',
      workspace_id: WS_SZCO_ID,
      name: 'Tech Solutions s.r.o.',
      ico: '46333111',
      dic: '2023111000',
      ic_dph: 'SK2023111000',
      address: 'Einsteinova 25, 851 01 Bratislava',
      email: 'invoices@techsolutions.sk',
      iban: 'SK7502000000003333222211',
      is_pinned: false,
      custom_color: null,
      created_at: daysAgo(40),
    },
    // s.r.o. workspace klienti
    {
      id: 'c0000006-0000-0000-0000-000000000006',
      workspace_id: WS_SRO_ID,
      name: 'Veľká Korporácia, a.s.',
      ico: '35777999',
      dic: '2020888666',
      ic_dph: 'SK2020888666',
      address: 'Plynárenská 1, 821 09 Bratislava',
      email: 'ap@velkakorporacia.sk',
      iban: null,
      is_pinned: true,
      custom_color: null,
      created_at: daysAgo(110),
    },
    {
      id: 'c0000007-0000-0000-0000-000000000007',
      workspace_id: WS_SRO_ID,
      name: 'Štart-up Lab',
      ico: '52111000',
      dic: '2120999888',
      ic_dph: null,
      address: 'Cvernovka, Bratislava',
      email: 'hello@startuplab.sk',
      iban: null,
      is_pinned: false,
      custom_color: null,
      created_at: daysAgo(80),
    },
  ],

  invoices: [
    // SZČO — paid recent
    {
      id: 'fa000001-0000-0000-0000-000000000001',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000001-0000-0000-0000-000000000001',
      number: '2026010',
      variable_symbol: '2026010',
      status: 'paid',
      issue_date: daysAgo(8),
      due_date: daysFromNow(6),
      delivery_date: daysAgo(8),
      currency: 'EUR',
      language: 'sk',
      items: [
        { name: 'UI design — landing page', qty: 1, unit: 'ks', unit_price: 1200, dph: 23 },
        { name: 'Konzultácie', qty: 4, unit: 'h', unit_price: 60, dph: 23 },
      ],
      subtotal: 1440,
      dph_amount: 331.20,
      total: 1771.20,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: daysAgo(2),
      created_at: daysAgo(8) + 'T09:30:00Z',
    },
    // SZČO — issued, not yet due
    {
      id: 'fa000002-0000-0000-0000-000000000002',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000002-0000-0000-0000-000000000002',
      number: '2026009',
      variable_symbol: '2026009',
      status: 'issued',
      issue_date: daysAgo(5),
      due_date: daysFromNow(9),
      delivery_date: daysAgo(5),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Marketingové texty — kampaň jar', qty: 1, unit: 'ks', unit_price: 850, dph: 23 }],
      subtotal: 850,
      dph_amount: 195.50,
      total: 1045.50,
      notes: 'Splatnosť 14 dní.',
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: null,
      created_at: daysAgo(5) + 'T11:15:00Z',
    },
    // SZČO — overdue
    {
      id: 'fa000003-0000-0000-0000-000000000003',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000003-0000-0000-0000-000000000003',
      number: '2026008',
      variable_symbol: '2026008',
      status: 'issued',
      issue_date: daysAgo(35),
      due_date: daysAgo(7),
      delivery_date: daysAgo(35),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Logo + brand guidelines', qty: 1, unit: 'ks', unit_price: 600, dph: 23 }],
      subtotal: 600,
      dph_amount: 138,
      total: 738,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: null,
      created_at: daysAgo(35) + 'T14:00:00Z',
    },
    // SZČO — overdue 2
    {
      id: 'fa000004-0000-0000-0000-000000000004',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000004-0000-0000-0000-000000000004',
      number: '2026007',
      variable_symbol: '2026007',
      status: 'overdue',
      issue_date: daysAgo(50),
      due_date: daysAgo(20),
      delivery_date: daysAgo(50),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Menu redesign + tlačové podklady', qty: 1, unit: 'ks', unit_price: 320, dph: 23 }],
      subtotal: 320,
      dph_amount: 73.60,
      total: 393.60,
      notes: 'Druhá upomienka odoslaná.',
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: null,
      created_at: daysAgo(50) + 'T08:45:00Z',
    },
    // SZČO — paid older
    {
      id: 'fa000005-0000-0000-0000-000000000005',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000005-0000-0000-0000-000000000005',
      number: '2026006',
      variable_symbol: '2026006',
      status: 'paid',
      issue_date: daysAgo(40),
      due_date: daysAgo(26),
      delivery_date: daysAgo(40),
      currency: 'EUR',
      language: 'sk',
      items: [
        { name: 'Web app prototyp', qty: 1, unit: 'ks', unit_price: 2400, dph: 23 },
        { name: 'Stretnutia + kick-off', qty: 6, unit: 'h', unit_price: 70, dph: 23 },
      ],
      subtotal: 2820,
      dph_amount: 648.60,
      total: 3468.60,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: daysAgo(22),
      created_at: daysAgo(40) + 'T16:20:00Z',
    },
    // SZČO — draft
    {
      id: 'fa000006-0000-0000-0000-000000000006',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000001-0000-0000-0000-000000000001',
      number: '2026011',
      variable_symbol: '2026011',
      status: 'draft',
      issue_date: iso(today),
      due_date: daysFromNow(14),
      delivery_date: iso(today),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Nasledujúci sprint — UI', qty: 40, unit: 'h', unit_price: 55, dph: 23 }],
      subtotal: 2200,
      dph_amount: 506,
      total: 2706,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: null,
      created_at: iso(today) + 'T07:00:00Z',
    },
    // SZČO — paid, even older
    {
      id: 'fa000007-0000-0000-0000-000000000007',
      workspace_id: WS_SZCO_ID,
      client_id: 'c0000002-0000-0000-0000-000000000002',
      number: '2026005',
      variable_symbol: '2026005',
      status: 'paid',
      issue_date: daysAgo(70),
      due_date: daysAgo(56),
      delivery_date: daysAgo(70),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Social posty + grafiky', qty: 12, unit: 'ks', unit_price: 35, dph: 23 }],
      subtotal: 420,
      dph_amount: 96.60,
      total: 516.60,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: daysAgo(54),
      created_at: daysAgo(70) + 'T13:00:00Z',
    },
    // s.r.o. invoices
    {
      id: 'fa000008-0000-0000-0000-000000000008',
      workspace_id: WS_SRO_ID,
      client_id: 'c0000006-0000-0000-0000-000000000006',
      number: '20260004',
      variable_symbol: '20260004',
      status: 'paid',
      issue_date: daysAgo(15),
      due_date: daysAgo(1),
      delivery_date: daysAgo(15),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Mesačná údržba systému', qty: 1, unit: 'mes', unit_price: 1800, dph: 23 }],
      subtotal: 1800,
      dph_amount: 414,
      total: 2214,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: daysAgo(3),
      created_at: daysAgo(15) + 'T10:00:00Z',
    },
    {
      id: 'fa000009-0000-0000-0000-000000000009',
      workspace_id: WS_SRO_ID,
      client_id: 'c0000007-0000-0000-0000-000000000007',
      number: '20260003',
      variable_symbol: '20260003',
      status: 'issued',
      issue_date: daysAgo(3),
      due_date: daysFromNow(11),
      delivery_date: daysAgo(3),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'MVP development — sprint 4', qty: 80, unit: 'h', unit_price: 65, dph: 23 }],
      subtotal: 5200,
      dph_amount: 1196,
      total: 6396,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: null,
      created_at: daysAgo(3) + 'T09:00:00Z',
    },
    {
      id: 'fa00000a-0000-0000-0000-00000000000a',
      workspace_id: WS_SRO_ID,
      client_id: 'c0000006-0000-0000-0000-000000000006',
      number: '20260002',
      variable_symbol: '20260002',
      status: 'paid',
      issue_date: daysAgo(45),
      due_date: daysAgo(31),
      delivery_date: daysAgo(45),
      currency: 'EUR',
      language: 'sk',
      items: [{ name: 'Predošlá faktúra — údržba', qty: 1, unit: 'mes', unit_price: 1800, dph: 23 }],
      subtotal: 1800,
      dph_amount: 414,
      total: 2214,
      notes: null,
      intro: null,
      payment_method: 'Bankový prevod',
      paid_at: daysAgo(30),
      created_at: daysAgo(45) + 'T10:00:00Z',
    },
  ],

  expenses: [
    {
      id: 'ex000001-0000-0000-0000-000000000001',
      workspace_id: WS_SZCO_ID,
      category: 'software',
      vendor_name: 'Adobe Systems',
      vendor_ico: null,
      amount: 71.99,
      dph_rate: 23,
      dph_amount: 13.46,
      date: daysAgo(2),
      description: 'Creative Cloud — mesačné predplatné',
      document_url: null,
      document_name: 'adobe-receipt.pdf',
      paid_via: 'card',
      created_at: daysAgo(2) + 'T08:00:00Z',
    },
    {
      id: 'ex000002-0000-0000-0000-000000000002',
      workspace_id: WS_SZCO_ID,
      category: 'fuel',
      vendor_name: 'Slovnaft',
      vendor_ico: '31322832',
      amount: 58.40,
      dph_rate: 23,
      dph_amount: 10.92,
      date: daysAgo(5),
      description: 'Tankovanie — služobná cesta Košice',
      document_url: null,
      document_name: 'slovnaft-bloček.jpg',
      paid_via: 'card',
      created_at: daysAgo(5) + 'T17:30:00Z',
    },
    {
      id: 'ex000003-0000-0000-0000-000000000003',
      workspace_id: WS_SZCO_ID,
      category: 'food',
      vendor_name: 'Restaurant Modra Hviezda',
      vendor_ico: null,
      amount: 24.80,
      dph_rate: 10,
      dph_amount: 2.25,
      date: daysAgo(7),
      description: 'Obed s klientom (Webdesign BA)',
      document_url: null,
      document_name: null,
      paid_via: 'card',
      created_at: daysAgo(7) + 'T13:15:00Z',
    },
    {
      id: 'ex000004-0000-0000-0000-000000000004',
      workspace_id: WS_SZCO_ID,
      category: 'hardware',
      vendor_name: 'Alza.sk',
      vendor_ico: '36562939',
      amount: 1450.00,
      dph_rate: 23,
      dph_amount: 271.14,
      date: daysAgo(28),
      description: 'MacBook Pro M4 — pracovný',
      document_url: null,
      document_name: 'alza-faktura.pdf',
      paid_via: 'transfer',
      created_at: daysAgo(28) + 'T11:00:00Z',
    },
    {
      id: 'ex000005-0000-0000-0000-000000000005',
      workspace_id: WS_SZCO_ID,
      category: 'services',
      vendor_name: 'O2 Slovakia',
      vendor_ico: '35848863',
      amount: 39.99,
      dph_rate: 23,
      dph_amount: 7.48,
      date: daysAgo(12),
      description: 'Mobilný paušál + dáta',
      document_url: null,
      document_name: null,
      paid_via: 'transfer',
      created_at: daysAgo(12) + 'T09:00:00Z',
    },
    {
      id: 'ex000006-0000-0000-0000-000000000006',
      workspace_id: WS_SZCO_ID,
      category: 'office',
      vendor_name: 'IKEA',
      vendor_ico: '35849429',
      amount: 189.00,
      dph_rate: 23,
      dph_amount: 35.34,
      date: daysAgo(55),
      description: 'Stolička do kancelárie',
      document_url: null,
      document_name: null,
      paid_via: 'card',
      created_at: daysAgo(55) + 'T16:00:00Z',
    },
    // s.r.o. expenses
    {
      id: 'ex000007-0000-0000-0000-000000000007',
      workspace_id: WS_SRO_ID,
      category: 'software',
      vendor_name: 'JetBrains s.r.o.',
      vendor_ico: '26395036',
      amount: 249.00,
      dph_rate: 23,
      dph_amount: 46.56,
      date: daysAgo(20),
      description: 'All-products pack — ročná licencia',
      document_url: null,
      document_name: null,
      paid_via: 'card',
      created_at: daysAgo(20) + 'T10:00:00Z',
    },
    {
      id: 'ex000008-0000-0000-0000-000000000008',
      workspace_id: WS_SRO_ID,
      category: 'marketing',
      vendor_name: 'Google Ireland',
      vendor_ico: null,
      amount: 480.00,
      dph_rate: 0,
      dph_amount: 0,
      date: daysAgo(10),
      description: 'Google Ads — kampaň marec',
      document_url: null,
      document_name: null,
      paid_via: 'card',
      created_at: daysAgo(10) + 'T12:00:00Z',
    },
  ],

  analytics_events: [],
  bank_transactions: [],
  szco_obligations: [],
  sro_dividends: [],
  ai_chat_messages: [],
  documents: [],
  catalog_items: [],
  stock_movements: [],

  // Mirror of RPO V2 (slovensko.digital). In production this is synced from
  // sync-rpo2 edge function. In dev-mock we seed ~15 well-known SK companies
  // so the autocomplete dropdown can be exercised offline.
  sk_companies: [
    { ico: '35763469', dic: '2020271076', ic_dph: 'SK2020271076', name: 'Tesla Liptovský Hrádok, a.s.',         legal_form: 'Akciová spoločnosť',          street: 'Pálenica',           building_number: '53/79', postal_code: '03301', municipality: 'Liptovský Hrádok', is_active: true,  terminated_on: null },
    { ico: '47843783', dic: '2024133331', ic_dph: 'SK2024133331', name: 'Slovak Telekom, a. s.',                 legal_form: 'Akciová spoločnosť',          street: 'Bajkalská',          building_number: '28',    postal_code: '81762', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '31322942', dic: '2020298362', ic_dph: 'SK2020298362', name: 'Tatra banka, a.s.',                     legal_form: 'Akciová spoločnosť',          street: 'Hodžovo námestie',   building_number: '3',     postal_code: '81106', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '35697270', dic: '2020356641', ic_dph: 'SK2020356641', name: 'IKEA Bratislava, s. r. o.',             legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Ivanská cesta', building_number: '18',    postal_code: '82104', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '35947761', dic: '2022019188', ic_dph: 'SK2022019188', name: 'Lidl Slovenská republika, v.o.s.',      legal_form: 'Verejná obchodná spoločnosť', street: 'Ružinovská',         building_number: '1E',    postal_code: '82102', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '36631124', dic: '2022100783', ic_dph: 'SK2022100783', name: 'Kaufland Slovenská republika v.o.s.',   legal_form: 'Verejná obchodná spoločnosť', street: 'Trnavská cesta',     building_number: '41/A',  postal_code: '83104', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '17321204', dic: '2020298786', ic_dph: 'SK2020298786', name: 'ESET, spol. s r.o.',                    legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Einsteinova', building_number: '24',    postal_code: '85101', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '35728347', dic: '2020260250', ic_dph: 'SK2020260250', name: 'Slovenská sporiteľňa, a.s.',            legal_form: 'Akciová spoločnosť',          street: 'Tomášikova',         building_number: '48',    postal_code: '83237', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '36856290', dic: '2022472030', ic_dph: 'SK2022472030', name: 'VÚB, a.s.',                             legal_form: 'Akciová spoločnosť',          street: 'Mlynské nivy',       building_number: '1',     postal_code: '82990', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '50306151', dic: '2120247419', ic_dph: 'SK2120247419', name: 'Pixel Federation, s. r. o.',            legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Plynárenská', building_number: '7/A',   postal_code: '82109', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '36631124', dic: '2022100783', ic_dph: 'SK2022100783', name: 'Sygic a. s.',                           legal_form: 'Akciová spoločnosť',          street: 'Twin City Tower, Mlynské nivy', building_number: '12', postal_code: '82109', municipality: 'Bratislava', is_active: true, terminated_on: null },
    { ico: '50221779', dic: '2120222100', ic_dph: 'SK2120222100', name: 'Websupport, s. r. o.',                  legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Karadžičova', building_number: '12',    postal_code: '82108', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '35802459', dic: '2021510049', ic_dph: 'SK2021510049', name: 'Martinus, s.r.o.',                      legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Gorkého',     building_number: '4',     postal_code: '03601', municipality: 'Martin',           is_active: true,  terminated_on: null },
    { ico: '36258709', dic: '2021717928', ic_dph: 'SK2021717928', name: 'Alza.sk s. r. o.',                      legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Bottova',     building_number: '7',     postal_code: '81109', municipality: 'Bratislava',       is_active: true,  terminated_on: null },
    { ico: '46064904', dic: '2023199910', ic_dph: 'SK2023199910', name: 'Pohoda zaniknutá s.r.o.',               legal_form: 'Spoločnosť s ručením obmedzeným', street: 'Hlavná',      building_number: '1',     postal_code: '04001', municipality: 'Košice',           is_active: false, terminated_on: '2024-12-31' },
  ],
};

export function createSeedStore() {
  return JSON.parse(JSON.stringify(seed));
}
